<template>
  <div class="yhq">
    <!--卡券列表-->
    <div class="common-box border-t0 h550" id="commonBox">
      <el-row class="row-one">
        <span class="row-one-title">卡券列表</span>
      </el-row>
      <el-form :model="searchForm" :inline="true" class="form-single-inline margin-t20">
        <el-form-item>
          <!-- searchForm.type -->
          <el-radio-group v-model="searchFormType" class="radio-single-btn" style="margin:0;" @change="typeChange">
            <el-radio-button label="可用卡券"></el-radio-button>
            <el-radio-button label="失效卡券"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <span class="aColor" @click="$router.push({name:'pointsExchange',params:{pathName:'coupon'}})" style="margin:0 15px 0 -10px;cursor: pointer;">去兑换</span>
        </el-form-item>
        <el-form-item label="查询条件：">
          <template v-if="searchFormType=='可用卡券'">
            <el-radio-group v-model="status1" class="radio-single-one" key="ky" @change="invalidCardChange1">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">未使用</el-radio>
              <el-radio :label="2">已冻结</el-radio>
            </el-radio-group>
          </template>
          <template v-else>
            <el-radio-group v-model="status2" class="radio-single-one" key="sx" @change="invalidCardChange">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">已使用</el-radio>
              <el-radio :label="2">已过期</el-radio>
            </el-radio-group>
          </template>
        </el-form-item>
        <el-form-item>
          <el-button v-show="searchFormType=='可用卡券'" type="search" @click="searchClick1">查询 <i class="el-icon-search"></i></el-button>
          <el-button v-show="searchFormType=='失效卡券'" type="search" @click="searchClick">查询 <i class="el-icon-search"></i></el-button>
        </el-form-item>
      </el-form>
      <!-- 可用卡券 -->
      <div v-show="searchFormType=='可用卡券'">
        <el-table :data="tableCoupon1" class="table-single" v-loading="loadingOne" element-loading-text="加载中...">
          <el-table-column label="卡券名称" prop="usename" width="300"></el-table-column>
          <el-table-column label="兑换日期" prop="startdate"></el-table-column>
          <el-table-column label="失效日期" prop="enddate"></el-table-column>
          <el-table-column label="状态" prop="status"></el-table-column>
          <el-table-column label="详情">
            <template slot-scope="scope">
              <span class="table-single-btn-normal" @click="seeFun(scope.row)">查看</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 页码 -->
        <el-pagination class="pagination-single" @size-change="handleSizeChangeOne" @current-change="handleCurrentChangeOne" :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="total" hide-on-single-page>
        </el-pagination>
      </div>
      <!-- 失效卡券 -->
      <div v-show="searchFormType=='失效卡券'">
        <el-table v-loading="loadingTwo" element-loading-text="加载中..." :data="tableCoupon2" class="table-single">
          <el-table-column label="卡券名称" prop="usename"></el-table-column>
          <el-table-column label="兑换日期" prop="startdate"></el-table-column>
          <el-table-column label="失效日期" prop="enddate"></el-table-column>
          <el-table-column v-if="couponStatus == '3'" label="使用日期" prop="useddate"></el-table-column>
          <el-table-column label="状态" prop="status"></el-table-column>
        </el-table>
        <!-- 页码 -->
        <el-pagination class="pagination-single" @size-change="handleSizeChangeTwo" @current-change="handleCurrentChangeTwo" :current-page.sync="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="total" hide-on-single-page>
        </el-pagination>
      </div>
      <div style="height:20px;"></div>
      <!-- <img src="../../assets/images/development.png" alt="" style="width:120px;height:110px;margin:100px 0 100px 45%;margin-left: 45%;"> -->
      <!-- 功能开发中 -->
      <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable1" :show-close="false">
        <img src="../../assets/images/development.png" alt="" style="width:120px;height:110px;">
        <span slot="footer" class="dialog-footer">
          <el-button type="normal1" @click="dialogVisable1 = false">确定</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

 <script>
export default {
  data () {
    return {
      dialogVisable1: false,
      searchFormType: '可用卡券',
      searchForm: {
      },
      //查询条件
      status1: 0,
      status2: 0,
      //表格数据
      tableCoupon1: [],
      tableCoupon2: [],
      //分页2
      pageNum: 0,
      pageSize: 10,
      total: 0,
      couponStatus: '1',  // 记录状态类型---1未使用2已冻结3已使用4已过期
      invalidVal1: '',
      invalidVal: '',
      //加载
      loadingOne: true,
      loadingTwo: true,
    };
  },
  mounted () {
    this.getCouponList()
  },
  methods: {
    handleSizeChangeOne (newSize1) {
      this.pageNum = 1;
      this.pageSize = newSize1
      this.getCouponList(this.pageNum, newSize1)
    },
    handleCurrentChangeOne (newPage1) {
      this.loadingOne = true
      this.pageNum = newPage1
      this.getCouponList(newPage1, this.pageSize)
    },
    // 分页
    handleSizeChangeTwo (newSize) {
      this.pageNum = 1;
      this.pageSize = newSize
      this.getCouponList(this.pageNum, newSize)
    },
    handleCurrentChangeTwo (newPage) {
      this.loadingTwo = true
      this.pageNum = newPage
      this.getCouponList(newPage, this.pageSize)
    },
    seeFun (row) {
      // this.dialogVisable1 = true
      this.$router.push({
        name: 'couponDetail',
        params: {
          message: row
        }
      })
    },
    //卡券列表选择
    typeChange (val) {
      // console.log(val);
      if (val == "可用卡券") {
        this.loadingOne = true
        this.couponStatus = '1,2'
        this.status1 = 0
        this.handleSizeChangeOne()
      } else {
        this.loadingTwo = true
        this.couponStatus = '3,4'
        this.status2 = 0
        this.handleSizeChangeTwo()
      }
      this.getCouponList()
    },
    //失效卡券选择
    invalidCardChange1 (val1) {
      this.invalidVal1 = val1
    },
    //失效卡券选择
    invalidCardChange (val) {
      this.invalidVal = val
    },
    //可用卡券查询
    searchClick1 () {
      this.loadingOne = true
      if (this.invalidVal1 == 1) {
        this.couponStatus = '1'
        this.getCouponList()
      } else if (this.invalidVal1 == 2) {
        this.couponStatus = '2'
        this.getCouponList()
      } else if (this.invalidVal1 == 0) {
        this.couponStatus = '1,2'
        this.getCouponList()
      }
    },
    //失效卡券查询
    searchClick () {
      this.loadingTwo = true
      if (this.invalidVal == 1) {
        this.couponStatus = '3'
        this.getCouponList()
      } else if (this.invalidVal == 2) {
        this.couponStatus = '4'
        this.getCouponList()
      } else if (this.invalidVal == 0) {
        this.couponStatus = '3,4'
        this.getCouponList()
      }
    },
    getCouponList (pageNum, pageSize) {
      this.$http.post(this.$apiPath.queryCoupon, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        custno: this.$commonJs.getCookie('u_custno1'),
        status: this.couponStatus,
        pageInt: (pageNum || this.pageNum || 1) - 1,
        page: pageSize || this.pageSize || 10
      }).then(res => {
        // console.log(res);
        if (res.data.code == "200") {
          this.loadingOne = false
          this.loadingTwo = false
          if (res.data.data) {
            this.total = res.data.data.totalNum
            let result = res.data.data.couponDetail
            if (result && result.length > 0) {
              let arrOne = new Array()
              result.forEach(item => {
                if (item.status == "已过期") {
                  arrOne.push(item)
                }
                item.startdate = item.startdate ? item.startdate.substr(0, 10) : '--'
                item.enddate = item.enddate ? item.enddate.substr(0, 10) : '--'
                item.useddate = item.useddate ? item.useddate.substr(0, 10) : '--'
                // monetary （0只能非货基使用 1货基可用）
                item.usename = item.monetary == 0 ? item.sname + '元（除货币外其它基金通用）' : item.sname
              });
              // console.log(result);
              this.tableCoupon2 = result
            } else {
              this.tableCoupon2 = []
            }
            this.tableCoupon1 = result
          }
        }
      }).catch(err => { })
    }
  }
}
 </script>

<style lang="less" scoped>
</style>
